export default (API) => ({
	//获取区域
	findRegion(params) {
		return API({
            url: `/saas/v1/WhpBranch/findRegion`,
            params
		})
    },
    // 获取企业机构
    findEntBranch(params) {
		return API({
            url: `/saas/v1/WhpBranch/findEntBranch`,
            params
		})
    },
})
